module.exports = "<div class=\"card card-wider card-cascade\" [innerHTML]=\"content\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/report-items/html-content-item/html-content-item.component.html
// module id = ./src/app/reports/report-items/html-content-item/html-content-item.component.html
// module chunks = main